import { Component, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CheckPageAccess } from 'src/app/components/authorize/check-page-access';
import { BBInvitations, BBInvitationsDefaultValues } from 'src/app/components/invitations/bb-invitations/bb-invitation';
import { BbInvitationFormComponent } from 'src/app/components/invitations/bb-invitations/bb-invitation-form/bb-invitation-form.component';
import { BbInvitationService } from 'src/app/services/bb-invitation.service';
import { ToastService } from 'src/app/services/toast-service.service';

@Component({
    selector: 'app-edit-bb-invitation',
    templateUrl: './edit-bb-invitation.component.html',
    styleUrls: ['./edit-bb-invitation.component.scss'],
    standalone: false
})
export class EditBbInvitationComponent {
  bbinvitation: BBInvitations = BBInvitationsDefaultValues();
  @ViewChild(BbInvitationFormComponent) bbinvitationForm!:BbInvitationFormComponent;
  isSubmitted=false;
  id: string = ''
  pageName = CheckPageAccess.EDITBBINVITATION
  constructor(
    private _bbinviteservice: BbInvitationService,
    private _toastservice: ToastService,
    private router: Router,
    private route:ActivatedRoute
  ){ }

  ngOnInit(){
    this.route.params.subscribe((params) => {
      this.id = params['id']
      this._bbinviteservice.getBBInvitationDetailsForUpdate(this.id).subscribe({
        next:(response)=>
          {
            this.bbinvitation=response;
            if (!this.bbinvitation.languageId) {
              this.bbinvitation.languageId = 1;
            }
          }
      })
    })
  }

  onSubmit()
  {
    this.isSubmitted=true;
    if(!this.bbinvitationForm.validateReqFileds())
    {
      return; 
    }
    this._bbinviteservice.updatebbinvitation(this.bbinvitation).subscribe({
      next:(response)=>
      {
        this._toastservice.showMessage("Invitation Updated Scuccessfully");
        this.router.navigate(['/bb-invite-list']);
      }
    })
  }

}
